module.exports = __webpack_public_path__ + "static/block4-616e56642763ef1b6cc6d19aed3a168b.jpg";